import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { ISaveEmployer } from "../interfaces/services";

export const saveEmployer = async (data: ISaveEmployer) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`

    try {
        const res = await api.post(`employers/admin`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};